import { isTriggerNode, type NodeModelWithId } from "@doitintl/cloudflow-commons";
import { ModelType, type UnwrappedApiServiceModelDescriptor, type Variables } from "@doitintl/cmp-models";

import { type NodeWitOutputModel } from "../useReferencedFieldContext";
import { createVariableMaps } from "./variableUtils";

export function getLabelDisplayInfo(
  label: string,
  model: UnwrappedApiServiceModelDescriptor,
  variables?: Variables
): { displayName: string; caption: string } {
  let displayName = label;
  let caption = generateCaption(model);

  if (label === "globalVariables" || label === "localVariables") {
    caption = "";
    displayName = label === "globalVariables" ? "Global Variables" : "Local Variables";
  } else if (variables) {
    const variableMaps = createVariableMaps(variables.globalVariables, variables.localVariables);
    const variableName = variableMaps.idToNameMap.get(label);
    const variableValue = variableMaps.idToValueMap.get(label);

    if (variableName) {
      displayName = variableName;
      caption = variableValue !== undefined ? String(variableValue) : "";
    }
  }

  return { displayName, caption };
}

export function generateCaption(model: UnwrappedApiServiceModelDescriptor): string {
  if (
    model.type === ModelType.LIST &&
    ![ModelType.STRUCTURE, ModelType.LIST, ModelType.MAP, ModelType.UNION].includes(model.member.model.type)
  ) {
    return `${model.member.model.type} ${model.type}`;
  }
  return model.type;
}

/**
 * Processes tokens for trigger nodes to handle variable references.
 * For trigger nodes with variables path, replaces the path structure and maps variable IDs to names for UI display.
 */
export function processTriggerNodeTokens(
  tokens: string[],
  referencedNode: NodeWitOutputModel,
  variableMaps: { idToNameMap: Map<string, string> }
): string[] {
  if (!isTriggerNode(referencedNode as unknown as NodeModelWithId)) {
    return tokens;
  }

  if (tokens.length >= 3 && tokens[1] === "variables") {
    tokens.splice(0, 2, "Variables");
    return tokens.map((token, index) => {
      if (index === 2) {
        const variableName = variableMaps.idToNameMap.get(token);
        return variableName || token;
      }
      return token;
    });
  }

  return tokens;
}
